import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { Users, Getters, Mutations, Actions, User } from '@/models/User.model';

// Inital state
const state: Users = {
  loggedInUser: {
    loggedIn: false,
    typeId: 0,
    type: '',
    displayName: '',
    lastLogin: '',
    clearanceLevel: 0,
  },
  users: [],
  userTypes: [],
};

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, Users> = {
  // --- Auth Functions ---
    displayMovementMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
        if ((state.loggedInUser.type === 'Tracking User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
      }
      return false;
    },

    displayWorkshopGroupMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
        if ((state.loggedInUser.type === 'Workshop User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
      }
      return false;
    },

    displayAdhocMaintenanceMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
        if ((state.loggedInUser.type === 'Workshop User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
      }
      return false;
    },

    displayDailyYardListMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
        if ((state.loggedInUser.type === 'Workshop User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
      }
      return false;
    },

    displayJobCardsMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 3) {
          return true;
        }
        if ((state.loggedInUser.type === 'Workshop User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
      }
      return false;
    },

    displayDailyPlannerMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 3) {
          return true;
        }
        if ((state.loggedInUser.type === 'Workshop User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
      }
      return false;
    },

    displayApprovalMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Administrator') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
      }
      return false;
    },

    displayVehicleMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Administrator') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
        if ((state.loggedInUser.type === 'Workshop User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Tracking User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
      }
      return false;
    },

    displayDriverGroupMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Administrator') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
        if ((state.loggedInUser.type === 'Workshop User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
      }
      return false;
    },

    displayDriverTypeMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
      }
      return false;
    },

    displayDriverRouteMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 5) {
          return true;
        }
      }
      return false;
    },

    displayDriverDetailsMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Administrator') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
        if ((state.loggedInUser.type === 'Workshop User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
      }
      return false;
    },

    displayDriverRolloutMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
      }
      return false;
    },

    displayDriverPaymentMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Administrator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
      }
      return false;
    },

    displayDriverAnnualLeaveMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Administrator') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 5) {
          return true;
        }
      }
      return false;
    },

    displayClientRatesGroupMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Administrator') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
      }
      return false;
    },

    displayRateSheetMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Administrator') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
      }
      return false;
    },

    displayRateAdjustmentsMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 3) {
          return true;
        }
      }
      return false;
    },

    displayClientMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Administrator') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
      }
      return false;
    },

    displayUserMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 3) {
          return true;
        }
      }
      return false;
    },

    displayBulkMessagingMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 3) {
          return true;
        }
      }
      return false;
    },

    displayReportScheduleMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 3) {
          return true;
        }
      }
      return false;
    },

    displaySearchGroupMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Administrator') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
        if ((state.loggedInUser.type === 'Tracking User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Workshop User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
      }
      return false;
    },

    displaySearchLoadsMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Administrator') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
        if ((state.loggedInUser.type === 'Tracking User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
      }
      return false;
    },

    displaySearchDriverPaymentsMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Administrator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 3) {
          return true;
        }
      }
      return false;
    },

    displaySearchRateAdjustmentsMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
      }
      return false;
    },

    displaySearchJobCardsMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Administrator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 3) {
          return true;
        }
        if ((state.loggedInUser.type === 'Workshop User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
      }
      return false;
    },

    displaySearchYardListMenuItem: (state) => {
      if (state.loggedInUser.loggedIn) {
        if ((state.loggedInUser.type === 'Super User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
        if ((state.loggedInUser.type === 'Operator') && state.loggedInUser.clearanceLevel >= 2) {
          return true;
        }
        if ((state.loggedInUser.type === 'Workshop User') && state.loggedInUser.clearanceLevel >= 1) {
          return true;
        }
      }
      return false;
    },
  // --- -------------- ---

  loggedInUser: (state) => state.loggedInUser,
  loggedInUserDisplayName: (state) => (state.loggedInUser.displayName.length > 0 ?  state.loggedInUser.displayName : 'Error: Contact Support').toUpperCase(),
  users: (state) => state.users,
  userTypes: (state) => state.userTypes,

  clearanceLevels: (state) => {
    return [1, 2, 3, 4, 5];
  },

  usersByType: (state) => (type: string): User[] => state.users.filter( (item: User) => item.userType === type),
};

// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, Users> = {
  resetLoggedInUser(state) {
    state.loggedInUser = {
      loggedIn: false,
      typeId: 0,
      type: '',
      displayName: '',
      lastLogin: '',
      clearanceLevel: 0,
    };
  },

  setLoggedInUser(state, { loggedInUser }) {
    state.loggedInUser = loggedInUser;
  },

  setUsers(state, { users }) {
    state.users = users;
  },

  setUserTypes(state, { userTypes }) {
    state.userTypes = userTypes;
  },
};

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, Users, Mutations, Getters> = {
  resetLoggedInUser({ commit }, payload) {
    commit('resetLoggedInUser', payload);
  },

  setLoggedInUser({ commit }, payload) {
    commit('setLoggedInUser', payload);
  },

  setUsers({ commit }, payload) {
    commit('setUsers', payload);
  },

  setUserTypes({ commit }, payload) {
    commit('setUserTypes', payload);
  },
};

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<Users, Getters, Mutations, Actions>('UserModule');

export const UserModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
